const parseDateValue = (value) => {
  if (!value) return null;
  const date =
    typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? new Date(`${value}T00:00:00`)
      : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateDDMMYYYY = (value, fallback = '-') => {
  const date = parseDateValue(value);
  if (!date) return fallback;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formatDateTimeDDMMYYYY = (value, fallback = '-') => {
  const date = parseDateValue(value);
  if (!date) return fallback;

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${formatDateDDMMYYYY(value, fallback)} ${hours}:${minutes}`;
};
